import React from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { contact, doctor } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12">
        <div>
          <p className="font-head text-2xl font-bold tracking-wide">
            ADAM A. ALBABA, <span className="text-gold">MD</span>
          </p>
          <p className="text-white/60 mt-1">{"Trauma \u2022 Foot & Ankle \u2022 Sports Medicine"}</p>
          <p className="text-white/70 text-sm leading-relaxed max-w-sm mt-8">{doctor.tagline}</p>
        </div>

        <div>
          <h4 className="font-head text-lg uppercase tracking-widest text-gold mb-4">Contact Our Office</h4>
          <div className="space-y-4 text-sm">
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 shrink-0 text-gold" />
              <div className="text-white/80">
                <p className="font-semibold">{contact.office}</p>
                <p className="text-white/60">{contact.area}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Mail className="w-5 h-5 shrink-0 text-gold" />
              <a href={`mailto:${contact.email}`} className="text-white/80 hover:text-gold transition-colors">{contact.email}</a>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="w-5 h-5 shrink-0 text-gold" />
              <a href={`sms:${contact.smsNumber}`} className="text-white/80 hover:text-gold transition-colors">{contact.phone}</a>
            </div>
            {/* runner icon at the very end, after contact our office */}
            <div className="pt-2">
              <img src={doctor.runner} alt="" aria-hidden="true" className="w-14 h-auto opacity-90" />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-5">
          <p className="text-white/40 text-xs tracking-widest uppercase">{"\u00a9 2025 ADAM A. ALBABA, MD | All Rights Reserved"}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
